import { z } from "zod";
import { zObjectId, zServiceProjectTask } from "@dobrh-monorepo/core";
import { HttpMethodEnum, HttpParamsTypeEnum, Route } from "../../../../../utils/route";

const requestSchema = z.object({
  serviceProjectId: zObjectId(),
  tasks: z.array(
    z.object({
      taskId: zObjectId(),
      isCompleted: z.boolean(),
      subTasks: z.array(
        z.object({
          subTaskId: zObjectId(),
          isCompleted: z.boolean(),
        }),
      ),
    }),
  ),
});

const responseSchema = z.array(zServiceProjectTask);

export default {
  method: HttpMethodEnum.POST,
  paramsType: HttpParamsTypeEnum.BODY,
  requestZodSchema: requestSchema,
  responseZodSchema: responseSchema,
} satisfies Route;
